import { useMemo } from "react";
import {
  NameExternalEvidence,
  NameInternalEvidence,
} from "../../types/nameEvidence";

const useEvidenceLogic = () => {
  const internalEvidenceTypeEnum = useMemo(() => "internal_evidence_type", []);

  const defaultNameInternalEvidence = useMemo<NameInternalEvidence>(() => {
    return {
      attribute_post: "",
      attribute_pre: "",
      name: "",
      internal_evidence_type: null,
    };
  }, []);

  const externalEvidenceTypeEnum = useMemo(() => "external_evidence_type", []);

  const defaultNameExternalEvidence = useMemo<NameExternalEvidence>(() => {
    return {
      attribute_post: "",
      attribute_pre: "",
      name: "",
      external_evidence_type: null,
    };
  }, []);

  return {
    internalEvidenceTypeEnum,
    externalEvidenceTypeEnum,
    defaultNameInternalEvidence,
    defaultNameExternalEvidence,
  };
};

export default useEvidenceLogic;
